export const CHECKBOX_SIZE = 15;
export const DROPDOWN_SIZE = [10, 7];
export const DROPDOWN_PADDING = [5, 7];
export const DROPDOWN_HIT_WIDTH = 24;
export const DEFAULT_ROW_HEIGHT = 21;
